<template>
  <el-form ref="ref_subjectForm" :model="subjectForm" :rules="subjectRules" label-width="100px">
    <el-form-item label="科目名称" prop="subject">
      <el-input v-model="subjectForm.subject" maxlength="20" placeholder="请输入科目名称" />
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input v-model="subjectForm.remark" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入备注" />
    </el-form-item>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SubjectPage',
  props: {
    subjectForm: {
      type: Object,
      default: () => {

      }
    }
  },
  data() {
    return {
      subjectRules: {
        subject: [{ required: true, message: '请输入科目名称', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }],
        remark: [
          { min: 1, max: 250, message: '长度在 1 到 200 个字符', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState('commonModule', ['orgAreaTree']),
    ...mapState('commonModule', ['selectOptionsLevel', 'selectOptionsSubject']),
    ...mapState('gardenManagement', ['textBookRules'])
  },
  watch: {
  },
  method: {

  }

}
</script>

<style>

</style>
